import { ProfessorAreaAssignmentEdit } from 'pages/professor_area/classrooms/components/TabAssignments/assignments';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'professor_area/classroom_assignments',
  pathTemplate: 'professor_area/classrooms/:classroomId/evaluations',
  label: 'Atividades',
  edit: ProfessorAreaAssignmentEdit,
  actions: ['list', 'show', 'edit', 'create', 'delete'],
  parentName: 'professor_area',
  route: 'professor_area/classrooms/:classroomId/assignments'
};

export default generateResources(resource);
